import { useEffect, useRef } from 'react';

export function useReportShortcuts(
    onSave: () => void,
    canSaveReport: boolean,
    onToggleSidebar?: () => void,
    onToggleRightSidebar?: () => void,
    onUndo?: () => void,
    onRedo?: () => void,
    onExportJson?: () => void,
) {
    const onSaveRef = useRef(onSave);
    const canSaveReportRef = useRef(canSaveReport);
    const onToggleSidebarRef = useRef(onToggleSidebar);
    const onToggleRightSidebarRef = useRef(onToggleRightSidebar);
    const onUndoRef = useRef(onUndo);
    const onRedoRef = useRef(onRedo);
    const onExportJsonRef = useRef(onExportJson);

    useEffect(() => {
        onSaveRef.current = onSave;
    }, [onSave]);

    useEffect(() => {
        canSaveReportRef.current = canSaveReport;
    }, [canSaveReport]);

    useEffect(() => {
        onToggleSidebarRef.current = onToggleSidebar;
    }, [onToggleSidebar]);

    useEffect(() => {
        onToggleRightSidebarRef.current = onToggleRightSidebar;
    }, [onToggleRightSidebar]);

    useEffect(() => {
        onUndoRef.current = onUndo;
    }, [onUndo]);

    useEffect(() => {
        onRedoRef.current = onRedo;
    }, [onRedo]);

    useEffect(() => {
        onExportJsonRef.current = onExportJson;
    }, [onExportJson]);

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.ctrlKey || e.metaKey) {
                if (e.key === 's' || e.key === 'S') {
                    e.preventDefault();
                    if (!canSaveReportRef.current) return;
                    onSaveRef.current();
                    return;
                }

                if (e.key === 'b' || e.key === 'B') {
                    if (e.shiftKey) {
                        if (onToggleRightSidebarRef.current) {
                            e.preventDefault();
                            onToggleRightSidebarRef.current();
                        }
                    } else if (onToggleSidebarRef.current) {
                        e.preventDefault();
                        onToggleSidebarRef.current();
                    }
                    return;
                }

                if (e.key === 'e' || e.key === 'E') {
                    if (!e.shiftKey || !onExportJsonRef.current) return;

                    e.preventDefault();
                    onExportJsonRef.current();
                    return;
                }

                if (e.key === 'z' || e.key === 'Z') {
                    const target = e.target as HTMLElement;
                    const isInput =
                        target instanceof HTMLInputElement ||
                        target instanceof HTMLTextAreaElement ||
                        target.isContentEditable;

                    if (isInput) return;

                    e.preventDefault();
                    if (e.shiftKey) {
                        onRedoRef.current?.();
                    } else {
                        onUndoRef.current?.();
                    }
                }
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
}
